import React, { PropTypes } from 'react';
import { format } from 'date-fns';
import DayPicker from 'react-day-picker';
import IconSVG from 'svg-inline-react';
import classNames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './SingleDatePickerControl.scss';

const POSITION = ['top', 'bottom'];

const MONTHS = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

const WEEKDAYS_LONG = [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
];

const WEEKDAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

class SingleDatePickerControl extends React.Component {

    static propTypes = {
        today: PropTypes.object,
        from: PropTypes.object,
        to: PropTypes.object,
        label: PropTypes.string,
        onChange: PropTypes.func,
        position: PropTypes.oneOf(POSITION),
        className: PropTypes.string,
    }

    static defaultProps = {
        today: new Date(),
        label: '',
        position: 'bottom',
    };

    state = {
        today: this.props.today.setHours(0, 0, 0, 0)
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this._handlePageClick, false);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this._handlePageClick);
    }

    _handlePageClick = (event) => {
        if ($(event.target).closest('.-dontHide').length === 0) {
            this.props.hideDaypicker();
        };
    };

    render() {
        var modifiers = {
            // disabled: (day) => day < this.state.today,

            sunday: (day) => day.getDay() === 0 || day.getDay() === 6,
        };
        var daypickerWrapperClass = classNames(
            'SingleDatePickerControl-daypickerWrapper',
            'SingleDatePickerControl-daypickerWrapper--' + this.props.position,
            { 'SingleDatePickerControl-daypickerWrapper--show': this.props.visible },
            '-dontHide'
        );

        return (
            <div className={daypickerWrapperClass}>
                <DayPicker
                    locale="ru"
                    firstDayOfWeek={1}
                    months={MONTHS}
                    weekdaysLong={WEEKDAYS_LONG}
                    weekdaysShort={WEEKDAYS_SHORT}
                    modifiers={modifiers}
                    onDayClick={this.props.onDaySelect} />
                <IconSVG src={require('!svg-inline!./exit.svg')}
                    className="SingleDatePickerControl-exit"
                    onClick={this.props.hideDaypicker}
                    title="Закрыть календарь" />
            </div>

        );
    }
}

export default SingleDatePickerControl;



// WEBPACK FOOTER //
// ./client/components/SingleDatePickerControl/SingleDatePickerControl.js